import { Handle, Position } from 'reactflow';

export default function EndNode() {
  return (
    <div className="p-3 bg-red-600 text-white rounded-lg shadow">
      <strong>End</strong>
      <Handle type="target" position={Position.Top} />
    </div>
  );
}
